import cancelBooking from './cancelBooking';

export default {
    cancelBooking,
};
